
import { observable, action, computed } from 'mobx';
import { RootStore } from './';
import { fetchWrapper } from '../common/Fetch';
import { default as jwtDecode } from "jwt-decode";

interface JwtTokenResponse {
    token: string
}

export class AuthStore {


    _rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @observable token = "";
    @observable name = "";
    @observable roles: string[] = [];
    @observable deliveryPointName?: string;

    @computed get isAuthenticated() {
        return this.token != null && this.token.length > 0;
    }

    @computed get isCallCentre() {
        return this.isAuthenticated && this.roles != undefined && this.roles.indexOf("CallCenterUser") > -1;
    }

    @computed get isFranchise() {
        return this.isAuthenticated && this.roles != undefined && this.roles.indexOf("FranchiseUser") > -1;
    }
    @computed get isDeliveryPoint() {
        return this.isAuthenticated && this.roles != undefined && this.roles.indexOf("DeliveryPointUser") > -1;
    }

    isInRole(role: string) {
        return this.isAuthenticated && this.roles != undefined && this.roles.indexOf(role) > -1;
    }

    @action logIn(userName: string, password: string, rememberMe: boolean) {
        fetchWrapper('api/token', {
            method: 'POST',
            body: JSON.stringify({ UserName: userName, Password: password, RememberMe: rememberMe }),
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<JwtTokenResponse>)
            .then(result => {
                this.setToken(result.token);
                this._rootStore.rejectionsStore.loadNewRejectionsCount();
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action logout() {
        this.token = "";
        this.roles = [];
    }

    @action private setToken(token?: string) {

        if (token != null && token.length > 0) {
            const payload = token.split(".")[1];
            const payloadObj: any = jwtDecode(payload, { header: true });
            const roles = payloadObj["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
            const name = payloadObj["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"]
            this.deliveryPointName = payloadObj["DeliveryPointName"];
            this.roles = roles;
            this.name = name;
        }
        else
            this.roles = [];

        this.token = token || "";
    }
}